import api from '../index'
import urls from './url'
import appHelper from '@/utils/AppHelper'

export default {
  /**
   * post带上token
   * @param {*} url
   * @param {*} params
   */
  post(url, params) {
    var tokenInfo = appHelper.getUserTokenInfo();
    var headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'token': tokenInfo.Token
    }
    return api.post(url, params, headers)
  },
  /**
   * 公众号授权
   * @param {*} params
   */
  auth(params) {
    return api.post(urls.auth, params)
  },
  /**
   * 获取 JS-SDK 配置信息
   * @param {*} params
   */
  getWxConfig(params) {
    return api.post(urls.getWxConfig, params)
  },
  /**
   * 获取微信用户信息
   * @param {*} params
   */
  getWxUserInfo(params) {
    return api.post(urls.getWxUserInfo, params)
  },
  /**
   * 获取用户token
   * @param {*} params
   */
  createUserToken(params) {
    return api.post(urls.createUserToken, params)
  },
  /**
   * 更改用户token
   * @param {*} params
   */
  changeUserToken(params) {
    return this.post(urls.changeUserToken, params)
  },
  /**
   * 获取用户的自定义数据
   * @param {*} params
   */
  getUserCustomData(params) {
    return this.post(urls.getUserCustomData, params)
  },
  /**
   * 验证授权是否有效
   * @param {*} params
   */
  verifiAuth(params) {
    return this.post(urls.verifiAuth, params)
  },
  /**
   * 根据openid获取用户信息
   * @param {*} params
   */
  getUserInfoByOpenid(params) {
    return api.post(urls.getUserInfoByOpenid, params)
  },
  /**
   *  插入页面浏览历史记录
   * @param {*} params
   */
  insertBrowseHist(params) {
    return api.post(urls.insertBrowseHist, params)
  },
  /**
   * 获取微信公众号关注情况
   * @param {*} params
   */
  getFollowPublicAccount(params) {
    return api.post(urls.getFollowPublicAccount, params)
  }
}
